import Loading from "components/common/Loading";
import React, { Suspense, useCallback, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import style from "css/appMobile.module.css";
import Wrapper from "components/app/wrapper";
import Container from "components/app/container";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "redux/slices/alertSlice";
import { ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import NotFound from "pages/common/notFound";
import Mypage from "./mypage/mypageMobile";
import Header from "components/mobile/header";
import Address from "pages/address/mobile/addressMobile";
import Meeting from "./meeting/meeting";
import Qr from "pages/qr/qr";
import HotDesking from "pages/hotdesking/HotDesking";
import Calendar from "./meeting/calendar";
import Room from "./meeting/room";

/**
 * 파일명: appMobile.js
 * 작성자: 강연승
 * 작성일자: 25.02.04
 * 설명: mobile app router
 */
function AppMobile() {
  //state
  const [init, setInit] = useState(true);
  const [menuOpen, setMenuOpen] = useState(true);

  //location
  const location = useLocation();

  //dispatch
  const dispatch = useDispatch();

  //navigate
  const navigate = useNavigate();

  //translation
  const { t } = useTranslation();

  //payload
  const userPayload = useSelector((state) => state.user);
  const allowPagesPayload = useSelector((state) => state.allowPage);

  const checkAllowPage = useCallback(() => {
    const list = allowPagesPayload.pages;
    const pathName = new URL(window.location.href).pathname.split("/");
    const filter = list.filter((el) =>
      pathName[pathName.length - 1].includes(el.MENU_URL)
    );

    if (filter.length > 0) {
      return true;
    } else {
      return false;
    }
  }, [allowPagesPayload.pages]);

  useEffect(() => {
    if (userPayload.name !== "") {
      if (!checkAllowPage()) {
        dispatch(
          openAlert({
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.PAGE_NOT_AVAILABLE"),
            submitEventHandler: () => {
              navigate(process.env.REACT_APP_CLIENT_URL + "app/address", {
                state: { type: "card" },
              });
            },
          })
        );
      }
    }
  }, [checkAllowPage, dispatch, navigate, t, userPayload.name]);

  useEffect(() => {
    if (init) {
      if (location.state !== null && location.state !== undefined) {
        setMenuOpen(location.state.isMenuOpen);
      }
      setInit(false);
    }
  }, [init, location.state]);

  return (
    <div className={style.container}>
      <main className={style.main}>
        <Wrapper isOpen={menuOpen}>
          <Header />

          <ConfigProvider
            theme={{
              token: {
                fontFamily: "Spoqa Han Sans Neo",
              },
              components: {
                Spin: {
                  colorPrimary: "#1cb691",
                },
                Pagination: {
                  colorPrimary: "#1cb691",
                },
              },
            }}
          >
            <Container>
              <Suspense fallback={<Loading />}>
                <Routes>
                  <Route path="/mypage/*" element={<Mypage />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/room" element={<Room />} />
                  <Route path="/address" element={<Address />} />
                  <Route path="/meeting/*" element={<Meeting />} />
                  <Route path="/checkin" element={<Qr />} />
                  <Route path="/hotdesking" element={<HotDesking />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </Container>
          </ConfigProvider>
        </Wrapper>
      </main>
    </div>
  );
}

export default AppMobile;
